import { html, ref, repeat, when } from '@microsoft/fast-element';
import { QuadrantGrid } from './quadrant-grid';
import { VPPA_COLUMNS } from './column-config';

export const QuadrantGridTemplate = html<QuadrantGrid>`
  <zero-grid-pro class="grid-styles" only-template-col-defs sideBar="" ${ref('vppaQuadrantGrid')}>
    ${repeat(
      (x) => VPPA_COLUMNS(x),
      html`
        <grid-pro-column :definition="${(x) => x}"></grid-pro-column>
      `
    )}
  </zero-grid-pro>

  ${when(
    (x) => x.enableProceedButton,
    html<QuadrantGrid>`
      <div class="footer">
        <zero-button appearance="primary" @click="${(x) => x.proceedToNextStep()}">
          Proceed to Drilldown
        </zero-button>
      </div>
    `
  )}
`;
